import { GET } from "../../utils/constants/verbs";
import { put, takeLatest } from "redux-saga/effects";
import requestAPI from "../../helpers/requestHelpers";
import { Types } from "../ducks/events";
import urls from "../../utils/constants/urlsAPI";

function* requestEventsInfo({ date, cityId }) {
  try {
    const { events } = yield requestAPI({
      verb: GET,
      endPoint: urls.getDateEvents,
      query: `?date=${date}&city_id=${cityId}`
    });
    return events;
  } catch (e) {
    yield put({
      type: Types.EVENTS_REQUEST_FAIL,
      error: e
    });
  }
}

function* requestEvents() {
  try {
    const { dates } = yield requestAPI({
      verb: GET,
      endPoint: urls.listEventsDates
    });
    const events = dates.map(event => {
      return {
        city: event.city_id,
        cityName: event.city_name,
        countryId: event.country_id,
        date: event.date,
        eventIsOnHolding: event.events_in_on_holding
      };
    });
    for (let item in events) {
      events[item].subEvents = yield requestEventsInfo({
        date: events[item].date,
        cityId: events[item].city
      });
    }
    yield put({
      type: Types.EVENTS_REQUEST_SUCCESS,
      events
    });
  } catch (e) {
    yield put({
      type: Types.EVENTS_REQUEST_FAIL,
      error: e
    });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.EVENTS_REQUEST, requestEvents);
}
